
export const getDeviceInfo = () => {
  const userAgent = navigator.userAgent;

  return {
    userAgent,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    browser: getBrowserInfo(userAgent),
    os: getOS(userAgent),
  };
};

const getBrowserInfo = (ua) => {
  if (ua.includes("Chrome") && !ua.includes("Edg")) return "Chrome";
  if (ua.includes("Firefox")) return "Firefox";
  if (ua.includes("Safari") && !ua.includes("Chrome")) return "Safari";
  if (ua.includes("Edg")) return "Edge";
  if (ua.includes("OPR") || ua.includes("Opera")) return "Opera";
  return "Unknown";
};

const getOS = (ua) => {
  if (ua.includes("Windows NT 10.0")) return "Windows 10";
  if (ua.includes("Windows NT 6.1")) return "Windows 7";
  if (ua.includes("Mac")) return "macOS";
  if (ua.includes("X11")) return "UNIX";
  if (ua.includes("Linux")) return "Linux";
  if (/Android/.test(ua)) return "Android";
  if (/iPhone|iPad|iPod/.test(ua)) return "iOS";
  return "Unknown";
};
